import { assets } from '@/helpers/common'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React from 'react'

function AboutUsBanner() {
  return (
    <>
      <section className={'location-box-storage-banner hidden xl:block'}>
        <div className={'main-banner'}>
          <div className='banner-image-left xl-mx:hidden'>
            <img src={assets('images/about-us/location.png')} alt={''} />
          </div>
          <div className='container mx-auto pt-24 pb-28 lg-mx:pt-8 lg-mx:pb-8'>
            <div className='row sm-mx:flex-col-reverse'>
              <div className='w-full text-center'>
                <LazyMotion features={domAnimation}>
                  <m.div
                    // key={`animation-about-us`}
                    animate={{ scale: 1, y: 0, opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    initial={{ scale: 0.8, y: 100, opacity: 0 }}
                  >
                    <div className='banner-content text-center'>
                      <h2 className='text-4xl2 font-bold text-secondary mb-4'>About Us</h2>
                      <p className='text-2xl font-normal text-gray-400 mb-7'>
                        "Ship And Storage" combines shipping and storage, making it simple to send boxes to{' '}
                        <br className='lg-mx:hidden' /> self-storage and receive them back, even if you're in another
                        city. "Ship And Storage" provides <br className='lg-mx:hidden' /> services such as
                        ship-to-school, ship-to-office, and ship-to-home that are ideal for job{' '}
                        <br className='lg-mx:hidden' /> relocation, study abroad, and summer vacations.
                      </p>
                    </div>
                  </m.div>
                </LazyMotion>
              </div>
            </div>
          </div>
          <div className='banner-image-right xl-mx:hidden'>
            <img src={assets('images/about-us/airoplane.png')} alt={''} />
          </div>
        </div>
      </section>
    </>
  )
}

export default AboutUsBanner
